import { Button, ButtonProps, Stack, styled } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  clear: {
    props?: ButtonProps;
    label?: string;
    visible?: boolean;
  };
  cancel: {
    props?: ButtonProps;
    label?: string;
    visible?: boolean;
  };
  apply: {
    props?: ButtonProps;
    label?: string;
    visible?: boolean;
  };
} & React.PropsWithChildren;

const StyledStack = styled(Stack)`
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  align-self: stretch;
`;

export function FooterWithSlot(props: Props) {
  const { t } = useTranslation();

  const {
    clear: {
      label: clearLabel = t('filters.actions.clear'),
      visible: clearVisible = true,
      props: clearProps,
    },
    cancel: {
      label: cancelLabel = t('filters.actions.cancel'),
      visible: cancelVisible = true,
      props: cancelProps,
    },
    apply: {
      label: applyLabel = t('filters.actions.apply'),
      visible: applyVisible = true,
      props: applyProps,
    },
  } = props;

  return (
    <StyledStack>
      <Stack flexGrow={1} flexDirection='row'>
        {clearVisible && (
          <Button variant='text' {...clearProps}>
            {clearLabel}
          </Button>
        )}
        {props.children}
      </Stack>
      <Stack flexGrow={2} flexDirection='row' justifyContent='flex-end' gap={2}>
        {cancelVisible && (
          <Button variant='text' {...cancelProps}>
            {cancelLabel}
          </Button>
        )}
        {applyVisible && (
          <Button {...applyProps} variant='contained'>
            {applyLabel}
          </Button>
        )}
      </Stack>
    </StyledStack>
  );
}
